<template>
  <div>
    <section class="footer-cta">
      <div class="footer-cta-inner">
        <p class="footer-cta-kicker">{{ texts.kicker }}</p>
        <h2 class="footer-cta-title">{{ texts.title }}</h2>
        <p class="footer-cta-description">
          {{ texts.description }}
        </p>
        <a
          class="footer-cta-button"
          :href="ctaHref"
        >
          {{ texts.button }}
        </a>
      </div>
    </section>

    <footer aria-label="footerHeading" class="footer-shell">
      <div class="footer-card">
        <div class="footer-top">
          <section class="footer-brand">
            <p class="footer-eyebrow">{{ texts.company }}</p>
            <h3 class="footer-company">{{ texts.companyName }}</h3>
            <p class="footer-summary">
              {{ texts.summary }}
            </p>
          </section>

          <section class="footer-column">
            <p class="footer-eyebrow">{{ texts.contact }}</p>
            <div class="footer-meta-group">
              <span class="footer-label">{{ texts.addressLabel }}</span>
              <p class="footer-value">
                {{ texts.address }}
              </p>
            </div>
            <div class="footer-meta-group">
              <span class="footer-label">{{ texts.emailLabel }}</span>
              <a href="mailto:keith.lu@hysenglobal.com" class="footer-value footer-mail">
                keith.lu@hysenglobal.com
              </a>
            </div>
          </section>

          <section class="footer-column">
            <p class="footer-eyebrow">{{ texts.publicPages }}</p>
            <div class="footer-links">
              <router-link :to="{ name: 'spApiComplianceDetail' }" class="footer-link-chip">
                {{ texts.links.compliance }}
              </router-link>
              <router-link :to="{ name: 'BrandAnalyticsDetail' }" class="footer-link-chip">
                {{ texts.links.brand }}
              </router-link>
              <router-link :to="{ name: 'privacyDetail' }" class="footer-link-chip">
                {{ texts.links.privacy }}
              </router-link>
              <router-link :to="{ name: 'userDetail' }" class="footer-link-chip">
                {{ texts.links.user }}
              </router-link>
            </div>
          </section>
        </div>

        <div class="footer-bottom">
          <span>{{ texts.copyright }}</span>
          <span>{{ texts.support }}</span>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import { localeState } from "@/utils/locale";

export default {
  name: "FooterNav",
  data() {
    return {
      copy: {
        zh: {
          kicker: "Start Your Growth",
          title: "人效全面提升、业绩翻倍增长，从此刻开始",
          description: "GO GLOBAL CREDIT LIMTED为跨境电商团队提供精细化运营、品牌分析与数据合规支持。",
          button: "获取报价",
          company: "Company",
          companyName: "GO GLOBAL CREDIT LIMTED",
          summary: "面向亚马逊卖家与品牌团队，提供订单、履约、财务、广告及 Brand Analytics 等内部管理与分析能力。",
          contact: "联系方式",
          addressLabel: "地址",
          address: "RM A, 9/F, ETON BUILDING, 288 DES VOEUX ROAD CENTRAL, SHEUNG WAN, HK",
          emailLabel: "邮箱",
          publicPages: "公开页面",
          links: {
            compliance: "SP-API 合规说明",
            brand: "品牌分析功能",
            privacy: "隐私政策",
            user: "用户协议",
          },
          copyright: "@2021GO GLOBAL CREDIT LIMTED",
          support: "Amazon SP-API Public Developer Support",
        },
        en: {
          kicker: "Start Your Growth",
          title: "Boost Team Efficiency and Double Business Growth",
          description: "Hunan Panxian Intelligent Technology provides refined operations, brand analytics, and compliance support for cross-border commerce teams.",
          button: "Get a Quote",
          company: "Company",
          companyName: "GO GLOBAL CREDIT LIMTED",
          summary: "Built for Amazon sellers and brand teams, with internal tools for orders, fulfillment, finance, advertising, and Brand Analytics.",
          contact: "Contact",
          addressLabel: "Address",
          address: "RM A, 9/F, ETON BUILDING, 288 DES VOEUX ROAD CENTRAL, SHEUNG WAN, HK",
          emailLabel: "Email",
          publicPages: "Public Pages",
          links: {
            compliance: "SP-API Compliance",
            brand: "Brand Analytics",
            privacy: "Privacy Policy",
            user: "User Agreement",
          },
          copyright: "@2021GO GLOBAL CREDIT LIMTED",
          support: "Amazon SP-API Public Developer Support",
        },
      },
    };
  },
  computed: {
    locale() {
      return localeState.locale;
    },
    texts() {
      return this.copy[this.locale];
    },
    ctaHref() {
      return this.locale === "en"
        ? "mailto:keith.lu@hysenglobal.com?subject=Get%20a%20Quote"
        : "mailto:keith.lu@hysenglobal.com?subject=%E8%8E%B7%E5%8F%96%E6%8A%A5%E4%BB%B7";
    },
  },
};
</script>

<style scoped>
.footer-cta {
  background:
    radial-gradient(circle at top, rgba(132, 180, 255, 0.42), transparent 38%),
    linear-gradient(135deg, #1d4ed8, #2554fe 58%, #5da1ff);
  overflow: hidden;
  padding: 2.5rem 1rem 0;
  position: relative;
}

.footer-cta::after {
  background: linear-gradient(90deg, rgba(255, 255, 255, 0.18), transparent 30%, rgba(255, 255, 255, 0.12) 70%, transparent);
  bottom: 2rem;
  content: "";
  height: 1px;
  left: 8%;
  position: absolute;
  right: 8%;
}

.footer-cta-inner {
  color: #fff;
  margin: 0 auto;
  max-width: 70rem;
  padding: 1rem 1rem 4rem;
  text-align: center;
}

.footer-cta-kicker {
  color: rgba(255, 255, 255, 0.72);
  font-size: 0.8rem;
  letter-spacing: 0.18em;
  margin: 0;
  text-transform: uppercase;
}

.footer-cta-title {
  color: #fff;
  font-size: 2rem;
  font-weight: 700;
  line-height: 1.28;
  margin: 0.9rem auto 0;
  max-width: 54rem;
}

.footer-cta-description {
  color: rgba(255, 255, 255, 0.82);
  font-size: 1rem;
  line-height: 1.8;
  margin: 1rem auto 0;
  max-width: 46rem;
}

.footer-cta-button {
  background: rgba(255, 255, 255, 0.12);
  border: 1px solid rgba(255, 255, 255, 0.55);
  border-radius: 999px;
  color: #fff;
  display: inline-flex;
  margin-top: 1.75rem;
  padding: 0.9rem 1.7rem;
  text-decoration: none;
  transition: transform 0.2s ease, background-color 0.2s ease, border-color 0.2s ease;
}

.footer-cta-button:hover {
  background: #fff;
  border-color: #fff;
  color: #173169;
  transform: translateY(-2px);
}

.footer-shell {
  background:
    linear-gradient(180deg, #1f2430 0%, #181c26 100%);
  padding: 1.25rem 1rem 3rem;
}

.footer-card {
  background:
    linear-gradient(180deg, rgba(255, 255, 255, 0.04), rgba(255, 255, 255, 0.02));
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 1.5rem;
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.22);
  margin: 0 auto;
  max-width: 80rem;
  padding: 1.5rem;
  position: relative;
}

.footer-top {
  display: grid;
  gap: 1.5rem;
}

.footer-brand,
.footer-column {
  min-width: 0;
}

.footer-eyebrow {
  color: rgba(255, 255, 255, 0.48);
  font-size: 0.78rem;
  letter-spacing: 0.16em;
  margin: 0 0 0.9rem;
  text-transform: uppercase;
}

.footer-company {
  color: #fff;
  font-size: 1.9rem;
  font-weight: 700;
  line-height: 1.3;
  margin: 0;
  text-align: left;
}

.footer-summary {
  color: rgba(255, 255, 255, 0.72);
  font-size: 0.98rem;
  line-height: 1.9;
  margin: 1rem 0 0;
  max-width: 30rem;
  text-align: left;
}

.footer-meta-group + .footer-meta-group {
  margin-top: 1rem;
}

.footer-label {
  color: rgba(255, 255, 255, 0.46);
  display: block;
  font-size: 0.82rem;
  margin-bottom: 0.45rem;
}

.footer-value {
  color: #fff;
  display: block;
  font-size: 1.1rem;
  font-weight: 600;
  line-height: 1.7;
  margin: 0;
  text-align: left;
  text-decoration: none;
}

.footer-mail {
  color: #9fc2ff;
}

.footer-mail:hover {
  color: #fff;
}

.footer-links {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
}

.footer-link-chip {
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 999px;
  color: rgba(255, 255, 255, 0.84);
  padding: 0.7rem 1rem;
  text-decoration: none;
  transition: background-color 0.2s ease, border-color 0.2s ease, transform 0.2s ease;
}

.footer-link-chip:hover {
  background: rgba(82, 136, 255, 0.2);
  border-color: rgba(125, 167, 255, 0.5);
  color: #fff;
  transform: translateY(-1px);
}

.footer-bottom {
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  color: rgba(255, 255, 255, 0.5);
  display: flex;
  flex-direction: column;
  font-size: 0.88rem;
  gap: 0.5rem;
  margin-top: 1.5rem;
  padding-top: 1rem;
  text-align: left;
}

@media (min-width: 768px) {
  .footer-card {
    padding: 2rem;
  }

  .footer-top {
    grid-template-columns: 1.2fr 1fr;
  }

  .footer-column:last-child {
    grid-column: 1 / -1;
  }

  .footer-bottom {
    align-items: center;
    flex-direction: row;
    justify-content: space-between;
  }
}

@media (min-width: 1024px) {
  .footer-cta {
    padding-top: 4rem;
  }

  .footer-cta-inner {
    padding-bottom: 4.5rem;
  }

  .footer-cta-title {
    font-size: 3rem;
  }

  .footer-card {
    padding: 2.4rem;
  }

  .footer-top {
    grid-template-columns: 1.35fr 1fr 1fr;
    gap: 2rem;
  }

  .footer-column:last-child {
    grid-column: auto;
  }
}

dd,
dl,
h2,
h3,
p {
  margin: 0;
}
</style>
<style scoped>
.footer-cta {
  background: #edbf5e;
  padding: 74px 20px;
}
.footer-cta::after { display: none; }
.footer-cta-inner { color: #102d26; max-width: 820px; padding: 0; }
.footer-cta-kicker { color: rgba(16, 45, 38, 0.66); font-size: 11px; font-weight: 700; }
.footer-cta-title {
  color: #102d26;
  font-family: Georgia, "Times New Roman", serif;
  font-size: 44px;
  font-weight: 400;
  line-height: 1.12;
  margin-top: 18px;
}
.footer-cta-description { color: rgba(16, 45, 38, 0.72); font-size: 14px; }
.footer-cta-button {
  background: #102d26;
  border-color: #102d26;
  border-radius: 2px;
  color: #f6f3ea;
  font-size: 13px;
  margin-top: 26px;
  padding: 13px 21px;
}
.footer-cta-button:hover { background: #23463d; border-color: #23463d; color: #fff; transform: none; }
.footer-shell { background: #102d26; padding: 64px 36px 34px; }
.footer-card {
  background: transparent;
  border: 0;
  border-radius: 0;
  box-shadow: none;
  max-width: 1280px;
  padding: 0;
}
.footer-top { gap: 54px; grid-template-columns: 1.25fr 1fr 0.8fr; }
.footer-eyebrow { color: #edbf5e; font-size: 10px; font-weight: 700; }
.footer-company {
  color: #f6f3ea;
  font-family: Georgia, "Times New Roman", serif;
  font-size: 28px;
  font-weight: 400;
}
.footer-summary { color: rgba(246, 243, 234, 0.57); font-size: 13px; line-height: 1.8; }
.footer-label { color: rgba(246, 243, 234, 0.44); font-size: 11px; }
.footer-value { color: #f6f3ea; font-size: 13px; font-weight: 500; }
.footer-mail { color: #edbf5e; }
.footer-links { align-items: flex-start; flex-direction: column; gap: 0; }
.footer-link-chip {
  background: transparent;
  border: 0;
  border-bottom: 1px solid rgba(246, 243, 234, 0.14);
  border-radius: 0;
  color: rgba(246, 243, 234, 0.68);
  font-size: 12px;
  padding: 9px 0;
  width: 100%;
}
.footer-link-chip:hover { background: transparent; border-color: #edbf5e; color: #edbf5e; transform: none; }
.footer-bottom { border-color: rgba(246, 243, 234, 0.14); color: rgba(246, 243, 234, 0.38); font-size: 11px; margin-top: 54px; padding-top: 20px; }
@media (max-width: 767px) {
  .footer-cta-title { font-size: 34px; }
  .footer-shell { padding: 54px 20px 30px; }
  .footer-top { grid-template-columns: 1fr; }
}
</style>
